import { parse, format } from 'date-fns'

export function zordDbDatetimeToStr(dateTime: string | null): string {
    if (!dateTime) return ''

    try {
        const parsedDate = parse(dateTime, 'yyyy-MM-dd HH:mm:ssX', new Date())
        return format(parsedDate, 'dd/MM/yyyy HH:mm:ss')
    } catch (e) {
        console.error('Erro ao converter data:', dateTime, e)
        return dateTime
    }
}